'use client';

import {
    ReactCompareSlider,
    ReactCompareSliderHandle,
    ReactCompareSliderImage,
} from 'react-compare-slider';

export function CompareSlider(props) {
    const {
        beforeSrc,
        afterSrc,
        beforeAlt = '',
        afterAlt = '',
        className = '',
        imageClass = 'object-cover',
        imageStyle,
        beforeImageStyle,
        afterImageStyle,
    } = props;

    return (
        <ReactCompareSlider
            itemOne={
                <ReactCompareSliderImage
                    src={beforeSrc}
                    alt={beforeAlt}
                    className={`h-full w-full ${imageClass}`}
                    style={beforeImageStyle || imageStyle}
                    loading="lazy"
                />
            }
            itemTwo={
                <ReactCompareSliderImage
                    src={afterSrc}
                    alt={afterAlt}
                    className={`h-full w-full ${imageClass}`}
                    style={afterImageStyle || imageStyle}
                    loading="lazy"
                />
            }
            className={`h-full w-full ${className}`}
            aria-label="Before and after comparison"
            handle={
                <ReactCompareSliderHandle
                    linesStyle={{
                        width: 8,
                        boxShadow: '0 0 8px rgba(0,0,0,.5)',
                    }}
                    buttonStyle={{
                        width: 68,
                        height: 68,
                        borderWidth: 4,
                        pointerEvents: 'auto',
                        boxShadow: '0 0 10px rgba(0,0,0,.45)',
                    }}
                />
            }
            onlyHandleDraggable={false}
            style={{
                touchAction: 'none',
                pointerEvents: 'auto',
            }}
        />
    );
}
